/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import { hifenUrl } from '../../../utils/hifenUrl';
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import {
    IconFacebook,
    IconInstagram,
    IconLinkedin,
    IconThreads,
    IconTiktok,
    IconTwitter,
    IconYoutube
} from '../../../assets';
import { cities_types } from '../../../services/selectors';
import { BreakApart, formatSelects, isColorLight, removerAcentos, slugSegmentoFiltro } from '../../../utils/FunctionsGlobals';
import { appendCodsiteQuery } from '../../../utils/url';
import { trackMetaEvent } from '../../../utils/metaPixel';
import { SeloImobtotalLink } from '../selo-imobtotal/SeloImobtotal';
// utils
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import Popular from '../populares/Popular';
import styles from './About.module.css';
import FiliaisRodape from '../filiais-rodape/FiliaisRodape';

// Slug do tipo nos atalhos do rodapé. Nome sem "/" mantém a URL de sempre; com "/" usa o slug
// canônico — a barra crua virava um segmento a mais na rota e o atalho abria a lista inteira.
const slugTipoRodape = (label: any, codsite?: unknown) => {
    const bruto = String(label ?? '');
    if (!bruto) return '-';
    if (!bruto.includes('/')) {
        return removerAcentos(hifenUrl(bruto, codsite).replaceAll(' ', '-')).toLowerCase();
    }

    return slugSegmentoFiltro(bruto, codsite);
};

const AboutPieces: React.FC<{
    site: any;
    allCities: any;
    allRodape: any;
    allCitiesTipes?: any;
    origin?: any;
    codsite?: any;
    isMobile?: Boolean;
    hidePopular?: boolean;
}> = ({ site, allCities, allCitiesTipes, origin, codsite, isMobile,allRodape, hidePopular }) => {
    const showLoftBadge = Number(site?.id) === 1898;
    const isNovember = new Date().getMonth() === 10;
    const withCodsite = (href: string) => appendCodsiteQuery(href, codsite, origin);
    // META PIXEL: helper de rastreio dos links de rodapé (ViewContent)
    const trackFooter = (nome: string, cat: string) => () =>
        trackMetaEvent(site, 'ViewContent', { content_name: nome, content_category: cat });
    const corTextoAbout = site?.id == '2551'
        ? (isColorLight(site?.cor3) ? (site?.cor11 || 'black') : (site?.cor13 || 'white'))
        : (site?.cor3 == '#ffffff' || site?.cor3 == '#d6d6d6' ? 'black' : 'white');
    const corTituloAbout = site?.cor2 != site?.cor3 ? site?.cor2 : corTextoAbout;
    const infoBodyCitiesClassName = site?.id == '2551'
        ? `${styles.info_body_cities} ${styles.info_body_cities_2551}`
        : styles.info_body_cities;
    const corInfoBodyCities = site?.id == '2551' ? 'white' : site?.cor4;
    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: IconInstagram,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.threads || '',
            id: 6,
            icon: IconThreads,
            rede: 'Threads'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: IconFacebook,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: IconTwitter,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: IconTiktok,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: IconYoutube,
            rede: 'Youtube'
        },
        {
            href: site?.Dados?.Linkedin || '',
            id: 7,
            icon: IconLinkedin,
            rede: 'Linkedin'
        },
    ];
    // useState
    const [allTypes, setAllTypes] = useState<Array<Array<any>>>([]);
    const [host, setHost] = useState(origin);
    // methods
    const GetTypes = async () => {
        if(allCitiesTipes?.length > 0){
            const format = formatSelects(allCitiesTipes);
            const activeSeparator = BreakApart(format?.slice(0, 10), 10);
            setAllTypes(activeSeparator);
        } else {
            const infoCitiesAndTypes = await cities_types(origin, codsite);
            const format = formatSelects(infoCitiesAndTypes?.tipos);
            const activeSeparator = BreakApart(format?.slice(0, 10), 10);
            setAllTypes(activeSeparator);
        }
    };

    // useEffect
    useEffect(() => {
        GetTypes();
        if(!origin){
            setHost(window?.location?.host);
        }
    }, []);

    return (
        <>
            {!hidePopular && <Popular site={site} allRodape={allRodape} codsite={codsite} origin={origin}/>}
            {/* MULTI-FILIAIS: endereços de TODAS as filiais (null fora do modo popup). */}
            <FiliaisRodape site={site} fundo={site?.cor3} cor={corTextoAbout} />
            {/* BUILDER: âncora estável do bloco "rodape" — mesma chave em toda página
                que chama renderRodape() (cada página tem sua própria função local
                duplicada, mas todas delegam pra estes 3 componentes About*). */}
            <div
                className={styles.container}
                data-builder-section="rodape"
                style={{ backgroundColor: site?.cor3 }}
            >
                <div className={styles.header}>
                <div className={styles.container_info}>
                        <div className={styles.info_header} style={{ color: corTituloAbout }}>CONTATO</div>
                        {site?.id == "1714" ?
                            <div className={styles.info_body_not_hover} style={{ color: corTextoAbout }}>
                                {`${site?.Dados?.empresa}.`}
                            </div>
                        : null}
                        {site?.Dados?.endereco &&
                            <div className={styles.info_body_not_hover} style={{ color: corTextoAbout }}>
                                {`${site?.Dados?.endereco}`}
                            </div>
                        }
                        {
                            site?.Dados?.bairro && site?.Dados?.cidade &&
                            <div className={styles.info_body_not_hover} style={{ color: corTextoAbout }}>
                                {`${site?.Dados?.bairro} - ${site?.Dados?.cidade}`}
                            </div>
                        }
                        { site?.id != '1866' && site?.Dados?.endereco ?
                            <a className={infoBodyCitiesClassName} target="_blank" style={{background: site?.cor2, width: 115, color: corInfoBodyCities}}
                                href={site?.url_maps ? site?.url_maps : `https://www.google.com/maps/dir/${(site?.Dados?.endereco ? site?.Dados?.endereco+"-" : '')+(site?.Dados?.bairro+"-"+site?.Dados?.cidade)}`}
                                title='Ver localização da imobiliária no Google Maps'
                                rel="noopener noreferrer">
                                <svg
                                    viewBox="0 -10 100 100"
                                    height="16px"
                                    width="16px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                >
                                    <path d="M50 10.417c-15.581 0-28.201 12.627-28.201 28.201a28.074 28.074 0 005.602 16.873L45.49 86.823c.105.202.21.403.339.588l.04.069.011-.006a5.063 5.063 0 004.135 2.111c1.556 0 2.912-.708 3.845-1.799l.047.027.179-.31c.264-.356.498-.736.667-1.155L72.475 55.65a28.074 28.074 0 005.726-17.032c0-15.574-12.62-28.201-28.201-28.201zm-.279 42.498c-7.677 0-13.895-6.221-13.895-13.895 0-7.673 6.218-13.895 13.895-13.895s13.895 6.222 13.895 13.895c0 7.673-6.218 13.895-13.895 13.895z"></path>
                                </svg>
                                Abrir mapa
                            </a>
                        : null }
                        {site?.id != "1739" ?
                            <>
                                <div className={styles.info_body_not_hover} style={{ color: corTextoAbout }}>
                                    {`Email: ${site?.Dados?.email1 || site?.Dados?.email2}`}
                                </div>
                                {site?.id == "2551" ? (
                                    <div className={styles.info_body_not_hover} style={{ color: corTextoAbout }}>
                                        Email: aluguel@hachbart.com.br
                                    </div>
                                ) : null}
                            </>
                        : null}
                        {site?.Dados?.tel1 && site?.id != "1946" ?
                            <a
                                className={styles.info_body}
                                title='Entrar em contato com a imobiliária tel 1'
                                rel="noopener noreferrer"
                                href={site?.Dados?.tel1_whats ? (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`) : (site?.id == "1937" ? `tel:${(site?.Dados?.tel1)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel1)?.replace(/\D/g, '')}`)}
                                onClick={async (e) => {
                                    trackLead(site, null); // 🔥 Registra o evento Lead
                                    if (!site?.Dados?.tel1_whats) return; // fixo: deixa o <a href="tel:..."> agir
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                style={{ color: corTextoAbout }}
                            >
                                {site?.Dados?.tel1_whats ? <svg
                                    viewBox="0 0 16 16"
                                    height="24px"
                                    width="24px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                >
                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                                </svg> : null}

                                <div className={styles.margin_text} style={{ color: corTextoAbout }}>
                                    {`${
                                        site?.Dados?.tel1 + (site?.Dados?.tel1_nome ? " - "+site?.Dados?.tel1_nome : "")
                                    }`}
                                </div>
                            </a>
                        : null}
                        {site?.Dados?.tel2 && site?.id != "1946" ?
                            <a
                                className={styles.info_body}
                                title='Entrar em contato com a imobiliária tel 2'
                                rel="noopener noreferrer"
                                href={site?.Dados?.tel2_whats ? (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel2
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel2
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`) : (site?.id == "1937" ? `tel:${(site?.Dados?.tel2)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel2)?.replace(/\D/g, '')}`)}
                                onClick={async (e) => {
                                    trackLead(site, null); // 🔥 Registra o evento Lead
                                    if (!site?.Dados?.tel2_whats) return; // fixo: deixa o <a href="tel:..."> agir
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel2
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel2
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                style={{ color: corTextoAbout }}
                            >
                                {site?.Dados?.tel2_whats ? <svg
                                    viewBox="0 0 16 16"
                                    height="24px"
                                    width="24px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                >
                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                                </svg> : null}
                                <div className={styles.margin_text} style={{ color: corTextoAbout }}>
                                    {`${
                                        site?.Dados?.tel2 + (site?.Dados?.tel2_nome ? " - "+site?.Dados?.tel2_nome : "")
                                    }`}
                                </div>
                            </a>
                        :null}
                        {site?.Dados?.tel3 && site?.id != "1946" ?
                            <a
                                title='Entrar em contato com a imobiliária tel 3'
                                className={styles.info_body}
                                rel="noopener noreferrer"
                                href={site?.Dados?.tel3_whats ? (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel3
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel3
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`) : (site?.id == "1937" ? `tel:${(site?.Dados?.tel3)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel3)?.replace(/\D/g, '')}`)}
                                onClick={async (e) => {
                                    trackLead(site, null); // 🔥 Registra o evento Lead
                                    if (!site?.Dados?.tel3_whats) return; // fixo: deixa o <a href="tel:..."> agir
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel3
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel3
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                style={{ color: corTextoAbout }}
                            >
                                {site?.Dados?.tel3_whats ? <svg
                                    viewBox="0 0 16 16"
                                    height="24px"
                                    width="24px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                >
                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                                </svg> : null}
                                <div className={styles.margin_text} style={{ color: corTextoAbout }}>
                                    {`${
                                        site?.Dados?.tel3 + (site?.Dados?.tel3_nome ? " - "+site?.Dados?.tel3_nome : "")
                                    }`}
                                </div>
                            </a>
                        :null}
                        {site?.Dados?.tel4 && site?.id != "1946" ?
                            <a
                                className={styles.info_body}
                                title='Entrar em contato com a imobiliária tel 4'
                                rel="noopener noreferrer"
                                href={site?.Dados?.tel4_whats ? (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel4
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel4
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`) : (site?.id == "1937" ? `tel:${(site?.Dados?.tel4)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel4)?.replace(/\D/g, '')}`)}
                                onClick={async (e) => {
                                    trackLead(site, null); // 🔥 Registra o evento Lead
                                    if (!site?.Dados?.tel4_whats) return; // fixo: deixa o <a href="tel:..."> agir
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel4
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel4
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                style={{ color: corTextoAbout }}
                            >
                                {site?.Dados?.tel4_whats ? <svg
                                    viewBox="0 0 16 16"
                                    height="24px"
                                    width="24px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                >
                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                                </svg> : null}
                                <div className={styles.margin_text} style={{ color: corTextoAbout }}>
                                    {`${
                                        site?.Dados?.tel4 + (site?.Dados?.tel4_nome ? " - "+site?.Dados?.tel4_nome : "")
                                    }`}
                                </div>
                            </a>
                        :null}
                        {site?.Dados?.horario ?
                        <div className={styles.info_body_not_hover} style={{ color: corTextoAbout }}>
                            {`Horário de Atendimento: ${
                                site?.Dados?.horario
                            }`}
                        </div> : null}
                        <div className={styles.container1}>
                            {allSocials?.map((v) => {
                                if (v) {
                                    if (v.href) {
                                        return (
                                            <a
                                                aria-label={v.href}
                                                rel="noopener noreferrer"
                                                target="_blank"
                                                key={v.id}
                                                href={v.href}
                                                title={`Navegar para o ${v.rede} da imobiliária`}
                                                className={styles.adjust_img1}
                                            >
                                                <Image
                                                    alt={`Imagem rede social ${v.rede}`}
                                                    src={v.icon}
                                                    height={40}
                                                    width={40}
                                                />
                                            </a>
                                        );
                                    }
                                    return null;
                                }
                                return null;
                            })}
                        </div>
                    </div>
                    <div className={styles.container_info1}>
                        <div className={styles.info_header} style={{ color: corTituloAbout }}>IMÓVEIS POR TIPO</div>
                        <div className={styles.adjust_columns}>
                                <div className={styles.adjust_one_column}>
                                    { site?.transacoes[0] == 'Venda' ?
                                        <Link prefetch={false} href={withCodsite('/imoveis/venda/-/-/-/-')} passHref onClick={trackFooter('Para Venda', 'footer_institutional')}>
                                            <div title={`Imóveis para venda`} className={infoBodyCitiesClassName} style= {{ backgroundColor: site?.cor2 }}>
                                                <div className={styles.options} style= {{ color: corInfoBodyCities }}>Para Venda</div>
                                            </div>
                                        </Link>
                                        : site?.transacoes[0] == 'Aluguel' ?
                                        <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/-')} passHref onClick={trackFooter('Para Locação', 'footer_institutional')}>
                                            <div title={`Imóveis para locação`} className={infoBodyCitiesClassName} style= {{ backgroundColor: site?.cor2 }}>
                                                <div className={styles.options} style= {{ color: corInfoBodyCities }}>Para Locação</div>
                                            </div>
                                        </Link>
                                    : null }
                                    {site?.promocao ?
                                        <Link prefetch={false} href={withCodsite(`/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?promocao=1`)} passHref onClick={trackFooter(isNovember ? 'Black November' : 'Imóveis em Promoção', 'footer_institutional')}>
                                            <div title={`Imóveis em promoção`} className={infoBodyCitiesClassName} style= {{ backgroundColor: site?.cor2 }}>
                                                <div className={styles.options} style= {{ color: corInfoBodyCities }}>{isNovember ? "Black November" : "Imóveis em Promoção"}</div>
                                            </div>
                                        </Link>
                                    : null}
                                    {allTypes[0]?.map((e: any) => (
                                        <Link prefetch={false} href={withCodsite(`/imoveis/venda/-/-/-/${slugTipoRodape(e?.label, site?.id)}`)} passHref key={e?.value} onClick={trackFooter(e?.label, 'footer_property_type')}>
                                            <div
                                                style= {{ backgroundColor: site?.cor2 }}
                                                className={infoBodyCitiesClassName}
                                                title={`${e?.label} em ${site?.Dados?.cidade} e região`}
                                            >
                                                <div className={styles.options} style= {{ color: corInfoBodyCities }}>
                                                    {e?.label}
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                    {site?.id == 2146  &&
                                        <Link prefetch={false} href={withCodsite('/imoveis/venda/-/-/-/studio')} passHref onClick={trackFooter('Studio', 'footer_property_type')}>
                                            <div
                                                style= {{ backgroundColor: site?.cor2 }}
                                                className={infoBodyCitiesClassName}
                                                title={`Studio em ${site?.Dados?.cidade} e região`}
                                            >
                                                <div className={styles.options} style= {{ color: corInfoBodyCities }}>
                                                    Studio
                                                </div>
                                            </div>
                                        </Link>
                                    }
                                </div>
                        </div>
                    </div>
                    {allCities?.length ? (
                        <div className={styles.container_info1}>
                            <div className={styles.info_header} style={{ color: corTituloAbout }}>IMÓVEIS À {site?.transacoes[0].toUpperCase()} EM</div>
                            <div className={styles.adjust_cities}>
                                {(allCities?.length > 0 ? allCities : [])
                                    ?.slice(0, 20)
                                    ?.map((v: any) => (
                                        v?.label ?
                                        <Link prefetch={false} href={withCodsite(`/imoveis/${site?.transacoes[0].toLowerCase()}/${removerAcentos(v?.label).toLowerCase()}/-/-/-`.replaceAll(
                                            ' ',
                                            '-'
                                        ))} passHref key={v?.value} onClick={trackFooter(v?.label, 'footer_city')}>
                                            <div
                                                title={"Imóveis em " + v?.label}
                                            >
                                                <div
                                                    className={infoBodyCitiesClassName}
                                                    key={v?.value}
                                                    style= {{backgroundColor: site?.cor2, color: corInfoBodyCities}}
                                                >
                                                    {v?.label}
                                                </div>
                                            </div>
                                        </Link>
                                        :null

                                    ))}
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className={styles.header}>
                    <div className={`${styles.rodapeImg} ${showLoftBadge ? styles.footerLogoBadgeContainer : ''}`}>
                        {site?.url_logo && !isMobile ?
                            <Link prefetch={false} href={withCodsite('/')}>
                                <Image
                                    src={`${site?.url_logo}?v=${site?.contador_marca || 0}`}
                                    alt={`Imobiliária ${site?.Dados?.empresa}`}
                                    title={`Imobiliária ${site?.Dados?.empresa}`}
                                    className={styles.logo_welcome}
                                    height={150}
                                    width={350}
                                />
                            </Link>
                        : null}
                        {showLoftBadge ? (
                            <div
                                id="loft-badge"
                                data-agency-id="35202722000103"
                                style={{ width: 100, height: 100 }}
                            />
                        ) : null}
                    </div>
                </div>
                {site?.Dados?.creci ?
                    <div className={styles.creci} style={{ color: corTextoAbout }}>
                        {`CRECI: ${site?.Dados?.creci}`}
                    </div>
                : null}
                {Number(site?.id) === 2168 ?
                    <div className={styles.creci} style={{ color: corTextoAbout }}>
                        CNPJ: 56.171.086/0001-70
                    </div>
                : null}
                {site?.html_rodape ?
                    <div className={styles.creci} style={{ color: corTextoAbout }}
                        dangerouslySetInnerHTML={{
                            __html: site?.html_rodape,
                        }}>
                    </div>
                : null}

            {site?.copyright ?
                (!site?.EsconderRodapeSobressai &&
                <div className={styles.rodapeSobressai} style={site?.id == "2075" ? {background: "#011126", color: "#f6f6f6"} : {color: corTextoAbout}}>
                    {/* Selo ImobTotal: mesmo conteúdo em todos os rodapés (a faixa já é esta div). */}
                    <SeloImobtotalLink site={site} host={host} />
                </div>
                ) : null}
            </div>
            {showLoftBadge ? (
                <Script
                    id="loft-badge-script-1898"
                    defer
                    type="module"
                    src="https://loft-badge.loft.com.br/index.js"
                />
            ) : null}
        </>
    );
};

export default AboutPieces;
